/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientEvolutionAliases {
  LAYOUT_1 = 'layout-1',
  LAYOUT_PATIENT_EVOLUTION = 'layout-patient-evolution',
  LAYOUT_RELEASE = 'layout-release',
  PANEL_RELEASE = 'panel-release',
  PANEL_RELEASE_BUTTONS = 'panel-release-buttons',
  RELEASE_CANCEL_BUTTON = 'release-cancel-button',
  RELEASE_EVOLUTION_SUBTEXT = 'release-evolution-subtext',
  RELEASE_SUBMIT_BUTTON = 'release-submit-button',
  RELEASE_TITLE = 'release-title',
  RELEASE_TITLE_TEXT = 'release-title-text',
  SUBMIT_BUTTON = 'submit-button',
  TEXT_QUESTION = 'text-question',
}
export { PatientEvolutionAliases };
